import React from "react";
import Joyride, { STATUS, EVENTS } from "react-joyride";
import PropTypes from "prop-types";
import AuthContext from "../../../AuthContext";

const propTypes = {
  start: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function CompanyProfileTour({ start, onChange }) {
  const [run, setRun] = React.useState(() => {
    const initState = start;
    return initState;
  });

  const me = React.useContext(AuthContext);

  React.useEffect(() => {
    let featureTour = localStorage.getItem("FEATURE_TOUR") || "{}";
    featureTour = JSON.parse(featureTour);
    if (featureTour === "{}" || !featureTour.hasOwnProperty("COMPANY_PROFILE_TOUR")) {
      featureTour.COMPANY_PROFILE_TOUR = false;
      //wait for screen to load fully for very first time
      setTimeout(() => {
        setRun(true);
      }, 5000);
      featureTour = JSON.stringify(featureTour);
      localStorage.setItem("FEATURE_TOUR", featureTour);
    } else {
      setRun(start);
    }
  }, [start]);

  const userSteps = [
    {
      content: "Add Company to the Company watchlists!",
      placement: "top",
      styles: {
        options: {
          width: 300,
        },
      },
      target: ".add-to-company-watchlist",
      disableBeacon: true,
    },
    {
      content: <p>Follow Company for future updates</p>,
      //spotlightPadding: 20,
      placement: "bottom",
      styles: {
        options: {
          width: 300,
        },
      },
      target: ".follow-company",
      disableBeacon: true,
    },
    {
      content: "Visit Company's news feed to check the updates",
      placement: "bottom",
      styles: {
        options: {
          width: 300,
        },
      },
      target: ".news-feed-company",
      disableBeacon: true,
    },
    {
      content: "Check product menu!",
      placement: "top",
      styles: {
        options: {
          width: 300,
        },
      },
      target: ".company-product-menu",
    },
    {
      content: "Chat with the company!",
      placement: "top",
      styles: {
        options: {
          width: 300,
        },
      },
      target: ".company-chat",
    },
  ];

  const steps = [
    {
      content: "Add Company to the Company watchlists!",
      placement: "top",
      styles: {
        options: {
          width: 300,
        },
      },
      target: ".add-to-company-watchlist",
      disableBeacon: true,
    },
    {
      content: <p>Follow Company for future updates</p>,
      //spotlightPadding: 20,
      placement: "bottom",
      styles: {
        options: {
          width: 300,
        },
      },
      target: ".follow-company",
      disableBeacon: true,
    },
    {
      content: "Visit Company's news feed to check the updates",
      placement: "bottom",
      styles: {
        options: {
          width: 300,
        },
      },
      target: ".news-feed-company",
      disableBeacon: true,
    },
    {
      content: "Chat with the company!",
      placement: "top",
      styles: {
        options: {
          width: 300,
        },
      },
      target: ".company-chat",
    },
  ];

  const handleJoyrideCallback = (data) => {
    const { status, type, action } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    //const closedEvents = [EVENTS.TOOLTIP_CLOSE];

    if (finishedStatuses.includes(status) || action === "close") {
      setRun(false);
      onChange(false);
    }
  };
  return (
    <div>
      <Joyride
        callback={handleJoyrideCallback}
        continuous={true}
        run={run}
        disableScrolling={true}
        scrollToFirstStep={true}
        showProgress={true}
        showSkipButton={true}
        steps={me && Object.keys(me).length > 0 && me.userId ? userSteps : steps}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
      />
    </div>
  );
}

CompanyProfileTour.propTypes = propTypes;
